import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {Tr} from '../../../i18n/Tr'
import {KTIcon} from '../../../helpers'
import {useEffect, useState} from 'react'
import {fetchData, toasterrormsg} from '../../../../reusable'

export function MenuInner() {
  const t = Tr()
  var categoryId = sessionStorage.getItem('categoryId')

  const [vendorDetail, setVendorDetail] = useState({}) as any
  // view profile api call
  const viewprofile = async () => {
    var tmp: any = sessionStorage.getItem('vendor')
    tmp = JSON.parse(tmp)

    var param: any = {
      vendorId: String(tmp['vendorId']),
    }

    var response: any = await fetchData('public/viewProfile', param)

    if (response.status == '200') {
      var data = response.data[0]
      setVendorDetail(data)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    viewprofile()
  }, [])
  return (
    <>
      <MenuItem title={t('Dashboard')} to='dashboard/' />
      <MenuInnerWithSub
        title={t('Listing Setup')}
        to='/apps/'
        menuPlacement='bottom-start'
        menuTrigger='click'
        hasArrow={true}
      >
        {categoryId == '1' && (
          <>
            <MenuItem to={'../viewhotels/'} title={t('Accommodation Listing')} hasBullet={true} />
          </>
        )}
        {categoryId == '3' && (
          <>
            <MenuItem
              to={'../viewrestaurants/'}
              title={t('Cafe & Restaurants Listing')}
              hasBullet={true}
            />
          </>
        )}
        {categoryId == '4' && (
          <>
            <MenuItem
              to={'../viewspacerentals/'}
              title={t('Space Rentals Listing')}
              hasBullet={true}
            />
          </>
        )}
        {categoryId == '5' && (
          <>
            <MenuItem
              to={'../viewtourpackages/'}
              title={t('Tour Package Listing')}
              hasBullet={true}
            />
          </>
        )}
        {categoryId == '7' && (
          <>
            <MenuItem to={'../viewcarrentals/'} title={t('Car Rental Listing')} hasBullet={true} />
          </>
        )}
      </MenuInnerWithSub>
      {/* if category is not cafe & restaurant then show booking menu */}
      {categoryId != '3' && (
        <MenuInnerWithSub
          title={t('Bookings Management')}
          to='/apps/'
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={true}
        >
          {categoryId == '1' && (
            <>
              <MenuItem to={'../viewhotelbooking/'} title={t('Bookings')} hasBullet={true} />
              <MenuItem
                to={'../viewhotelcancelledbooking/'}
                title={t('Cancelled Bookings')}
                hasBullet={true}
              />
              <MenuItem to={'../viewhotelinventory/'} title={t('Inventory')} hasBullet={true} />
              <MenuItem
                to={'../viewratingandreviewbookingwise/'}
                title={t('Reviews & Ratings')}
                hasBullet={true}
              />
              <MenuItem
                to={'../viewrevenuelist/'}
                title={t('Revenue Breakdown')}
                hasBullet={true}
              />
            </>
          )}
          {categoryId == '4' && (
            <>
              <MenuItem to={'../viewspacerentalbooking/'} title={t('Bookings')} hasBullet={true} />
              <MenuItem
                to={'../viewspacecancelledbooking/'}
                title={t('Cancelled Bookings')}
                hasBullet={true}
              />
              <MenuItem to={'../viewspaceinventory/'} title={t('Inventory')} hasBullet={true} />
              <MenuItem
                to={'../viewratingandreviewbookingwise/'}
                title={t('Reviews & Ratings')}
                hasBullet={true}
              />
              <MenuItem
                to={'../viewrevenuelist/'}
                title={t('Revenue Breakdown')}
                hasBullet={true}
              />
            </>
          )}
          {categoryId == '5' && (
            <>
              <MenuItem to={'../viewtourpackagebooking/'} title={t('Bookings')} hasBullet={true} />
              <MenuItem
                to={'../viewtourcancelledbooking/'}
                title={t('Cancelled Bookings')}
                hasBullet={true}
              />
              <MenuItem to={'../viewtourinventory/'} title={t('Inventory')} hasBullet={true} />
              <MenuItem
                to={'../viewratingandreviewbookingwise/'}
                title={t('Reviews & Ratings')}
                hasBullet={true}
              />
              <MenuItem
                to={'../viewrevenuelist/'}
                title={t('Revenue Breakdown')}
                hasBullet={true}
              />
            </>
          )}
          {categoryId == '7' && (
            <>
              <MenuItem to={'../viewcarrentalbooking/'} title={t('Bookings')} hasBullet={true} />
              <MenuItem
                to={'../viewcarcancelledbooking/'}
                title={t('Cancelled Bookings')}
                hasBullet={true}
              />
              <MenuItem to={'../viewcarinventory/'} title={t('Inventory')} hasBullet={true} />
              <MenuItem
                to={'../viewratingandreviewbookingwise/'}
                title={t('Reviews & Ratings')}
                hasBullet={true}
              />
              <MenuItem
                to={'../viewrevenuelist/'}
                title={t('Revenue Breakdown')}
                hasBullet={true}
              />
            </>
          )}
        </MenuInnerWithSub>
      )}
      <MenuInnerWithSub
        title={t('Reports')}
        to='/apps/'
        menuPlacement='bottom-start'
        menuTrigger='click'
        hasArrow={true}
      >
        <MenuItem to={'../occupancyreport/'} title={t('Occupancy')} hasBullet={true} />
        <MenuItem to={'../guestreport/'} title={t('Guest')} hasBullet={true} />
        <MenuItem to={'../financialreport/'} title={t('Financial Report')} hasBullet={true} />
        <MenuItem to={'../couponreport/'} title={t('Coupon')} hasBullet={true} />
        <MenuItem to={'#'} disable={true} title={t('Analytics & Insights')} hasBullet={true} />
      </MenuInnerWithSub>
      <MenuInnerWithSub
        title={t('Promotions & Discounts')}
        to='/apps'
        menuPlacement='bottom-start'
        menuTrigger='click'
        hasArrow={true}
      >
        <MenuItem to={'../viewloyaltyprogram/'} title={t('Loyalty Program')} hasBullet={true} />
        {categoryId == '1' && (
          <MenuItem
            to={'../viewhotelcouponlist/'}
            title={t('Coupon Management')}
            hasBullet={true}
          />
        )}
        {categoryId == '4' && (
          <MenuItem
            to={'../viewspacecouponlist/'}
            title={t('Coupon Management')}
            hasBullet={true}
          />
        )}
        {categoryId == '5' && (
          <MenuItem to={'../viewtourcouponlist/'} title={t('Coupon Management')} hasBullet={true} />
        )}
        {categoryId == '7' && (
          <MenuItem to={'../viewcarcouponlist/'} title={t('Coupon Management')} hasBullet={true} />
        )}
        <MenuItem to={'#'} disable={true} title={t('Advertisement')} hasBullet={true} />
      </MenuInnerWithSub>
      <MenuInnerWithSub
        title={t('Help & Support')}
        to='/apps'
        menuPlacement='bottom-start'
        menuTrigger='click'
        hasArrow={true}
      >
        <MenuItem
          to={'../viewhelpandsupport/'}
          title={t('Support Requests')}
          hasBullet={true}
          vendorDetail={vendorDetail}
        />
        <MenuItem to={'#'} disable={true} title={t('Communication')} hasBullet={true} />{' '}
        {/*<MenuItem to={'../communication/'} title={t('Communication')} hasBullet={true} /> */}
        <MenuItem to={'../contactus/'} title={t('Contacts')} hasBullet={true} />
      </MenuInnerWithSub>
      <MenuInnerWithSub
        title={t('More')}
        to='/apps'
        menuPlacement='bottom-start'
        menuTrigger='click'
        hasArrow={true}
      >
        <MenuItem to={'#'} disable={true} title={t('Reported Content')} hasBullet={true} />
        <MenuItem to={'#'} disable={true} title={t('Integration')} hasBullet={true} />
      </MenuInnerWithSub>
      <a
        href='https://insayr.uz/partner-instructions'
        target={'_blank'}
        className='align-self-center btn btn-sm btn-bg-primary btn-active-primary text-white fw-bold text-nowrap'
      >
        {t('How To Use')} <i className='fa-solid fa-circle-chevron-right text-white ms-1'></i>
      </a>
    </>
  )
}
